import { crudRequest } from '@/services/api';
import { ds } from '@/models/fieldConv'

export default {
  namespace: 'druid',

  effects: {
    *druidFetch({ payload }, { put }) {
      const { index, effectName, filterCallBack } = payload
      const andFilters = []
      const inFilters = []
      filterCallBack(andFilters, inFilters)
      const params = {
        ...payload.params,
        dataSource: ds[index],
        andFilters,
        inFilters: inFilters
      }
      const data = yield crudRequest('/api/route/statistic', params);
      if (data && data.code === 1) {
        yield put({ type: effectName, payload: { data: JSON.parse(data.data) || [], dsIndex: index } });
      }
    },
  },

  reducers: {}
};
